import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";

export const getNotificationAsync = () => {
  const url = getUrl("getNotifications");
  return Call.get(url);
};

export const markAsReadAsync = (id) => {
  const url = getUrl("markAsRead")(id);
  return Call.post(url);
};

export const markAllAsReadAsync = () => {
  const url = getUrl("markAllAsRead");
  return Call.post(url);
};

export const deleteNotificationsAsync = () => {
  const url = getUrl("deleteAll");
  return Call.delete(url);
};
